import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';
import { validateTextArea, onPasteSanitize } from '../../js/summernote_utils';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'descriptionTextarea',
        'saveButton',
        'characterCounter',
        'characterCount',
    ];

    static minLength = 200;

    openModal(data) {
        $(this.descriptionTextareaTarget).summernote({
            toolbar: [
                ['style', ['bold', 'italic']],
                ['para', ['ul', 'ol']],
                ['toggleEditor'],
            ],
            tooltip: false,
            disableResizeEditor: true,
            placeholder: translations['profile.Write a description'],
            callbacks: {
                onPaste: onPasteSanitize,
                onChange: () => this.updateCounter(),
            },
        });

        $(this.descriptionTextareaTarget).parent().find('.note-editable').attr('aria-describedby', 'descriptionEditHint');

        $(this.element).modal({
            backdrop: 'static',
            focus: false,
            show: true,
        });

        // The stored HTML carries newlines between blocks (wpautop) and the template's
        // indentation. Browsers don't render them, but textContent counts them, and
        // save() would send them back. Drop whitespace next to block tags.
        const description = data
            .replace(/\s*(<\/?(?:p|ul|ol|li|br)\b[^>]*>)\s*/gi, '$1')
            .trim();

        if (description.length > 0) {
            $(this.descriptionTextareaTarget).summernote('code', description);
        }

        this.updateCounter();
    }

    save() {
        showPreloader();
        const cleanedDescription = validateTextArea($(this.descriptionTextareaTarget).parent().find('.note-editable'));

        $.ajax({
            url: routes['app_profile_descriptionfieldupdate'],
            data: { description: cleanedDescription },
            success: (response) => {
                if (response.status) {
                    $(this.element).modal('hide');

                    // Change old description with the correct transform of the text
                    $('#description-textarea-readonly').parent().find('.note-editable').html(response.description);
                    $('#description-textarea-readonly').html(response.description);

                    dataLayer.push({
                        event: 'dataLayer.gaEvent',
                        gaEvent: {
                            'category': 'Account',
                            'action': 'description | Success',
                            'label': GA_EVENT_LABEL,
                        },
                    });

                    window.location.reload();
                } else {
                    hidePreloader();
                    addAlert('danger', translations['profile.Min length error']);
                }
            },
            error: function(error) {
                const json = error.responseJSON;

                if (json && json.message) {
                    addAlert('danger', json.message);
                    hidePreloader();

                    return;
                }
                addAlert('danger', translations['profile.An unknown error occurred.']);
            },
        });
    }

    updateCounter() {
        // Same count as the server: text without tags, one per character (mb_strlen)
        const editable = $(this.descriptionTextareaTarget).parent().find('.note-editable').get(0);
        const length = editable ? Array.from(editable.textContent).length : 0;
        const tooShort = length < this.constructor.minLength;

        this.characterCountTarget.textContent = length;
        this.characterCounterTarget.classList.toggle('text-danger', tooShort);
        this.saveButtonTarget.disabled = tooShort;
    }
}
